/* Система Sysupdate. */
/* Функция sysupdateClient() создает объект oSysupdateClient для обновления данных на сервере. */
/* Функция sysupdateClient(oSysupdateBase) - начало работы по обновлению объектов. */
/* В качестве параметров принимаются: */
/* oSysupdateBase - базовый объект */
window.sysupdateClient = function(oSysupdateBase)
{
	var oSysupdateClient =
	{
		oSysupdateBase: null,
		oClient: null,
		oClientFull: null,
		bHandler: false,
		aClientSQL: [],
		iClientSQL: 0, // Текущий массив значений
		sSuffix: "_server_client", // суффикс для дампов БД объектов на сервере
		oServer: null,
		bSuccessful: true,
		iClientCount: 0,
		iClientSuccess: 0,
		ini: function(oSysupdateBase)
		{
			this.oSysupdateBase = oSysupdateBase;
			return this;
		},
		createClientContainer: function(aClients)
		{
			if( this.bSuccessful )
			{
				this.iCountClient = aClients.length;
				this.iClientSuccess = 0;
				this.oClient.html('');
				for( var i in aClients )
				{
					var aClient = aClients[i];
					this.oClient.append("<div class='checkbox-"+aClient.alias+"'><input type='checkbox' value='"+aClient.name+"' checked='checked' disabled='disabled'> "+aClient.name+"</div><br>");
					this.bHandler = true;
					this.oClientFull.show();
				}
				this.bSuccessful = false;
			}
		},
		createClientError: function()
		{
			this.oClient.html('Нет объектов для обновления.');
			this.oClientFull.show();
		},
		update: function(oFile, aClientSQL, oServer)
		{
			if( !this.bHandler ) return false;
			this.oServer = oServer;
			var oZipdata = this.oSysupdateBase.oSaveData,
				oAjaxClients = oZipdata.aResult.server.clients,
				aCheckboxes = this.oClient.find('input[type=checkbox]:checked'),
				aUpdateParam = [],
				iUpdate = 0,
				formdata = false;
			this.aClientSQL = aClientSQL;
			if( !aCheckboxes.length )
			{
				this.oSysupdateBase.html("Выберите объекты для обновления!", "important");
				this.oServer.parent.oButton.attr('disabled', false);
				this.oSysupdateBase.saveInformation();
				return false;
			}
			for( var o in oAjaxClients )
			{
				for( var i = 0; i < aCheckboxes.length; i++ )
				{
					if( oAjaxClients[o].name == aCheckboxes[i].value )
					{
						aUpdateParam[iUpdate] = [oAjaxClients[o].address, oAjaxClients[o].database, oFile.prop('files')[0], oAjaxClients[o].name, oAjaxClients[o].alias];
						iUpdate++;
						break;
					}
				}
			}
			if( !aUpdateParam.length )
			{
				this.oSysupdateBase.html("Не удалось сформировать параметры для обновления. Обратитесь к администратору.", "important");
				this.oSysupdateBase.saveInformation();
				return false;
			}
			this.oSysupdateBase.append("Приступаем к обновлению объектов.", "success");
		    this.clientsAjaxHandler(aUpdateParam);
		},
		clientsAjaxHandler: function(aaClients)
		{
			if( !aaClients )
			{
				this.oSysupdateBase.append("Обновления объектов завершены.", "default");
				var oZipdata = this.oSysupdateBase.oSaveData;
				if(oZipdata.aResult.server)
        		{
        			this.oSysupdateBase.append("Приступаем к обновлениям на сервере.", 'default');
					var aaActions = this.oServer.getUpdateData(oZipdata.aResult.server);
        			if(!aaActions.length)
        			{
        				this.oSysupdateBase.append("Сервер не требует обновления.","success");
        				this.oSysupdateBase.saveInformation();
        			}
        			else
        			{
        				this.oServer.ajaxHandler(aaActions);
        			}
        		}
				return true; // Закончили цикл без ошибок
			}
			var aaData = this.oSysupdateBase.getNewData(aaClients);
			if( aaData[0] ) this.clientsNewAjax(aaData[0], aaData[1]);
			return true;
		},
		addGood: function(sAlias)
		{
			var oCheckboxContainer = $('.checkbox-'+sAlias);
			oCheckboxContainer.find('input[type=checkbox]').attr('checked', false);
			oCheckboxContainer.find('input[type=checkbox]').attr('disabled', true);
			oCheckboxContainer.append('&nbsp;<i class="glyphicon glyphicon-ok"></i>');
		},
		addBad: function(sAlias){
			var oCheckboxContainer = $('.checkbox-'+sAlias);
			oCheckboxContainer.find('input[type=checkbox]').attr('checked', true);
			oCheckboxContainer.find('input[type=checkbox]').attr('disabled', false);
			oCheckboxContainer.append('&nbsp;<i class="glyphicon glyphicon-remove"></i>');
		},
		updateClientDB: function(aaClients, sIP, sDatabase, sUserName, sAlias, date, zipname)
		{
			var $this 		= this,
				formdata 	= (window.FormData) ? new FormData() : false,
				oErrorParam = {sAlias: sAlias, sUserName: sUserName, sColor: "important", aaClients: aaClients, sIP: sIP, sDatabase: sDatabase, date: date, zipname: zipname};
			if( !$this.aClientSQL ) // Нет sql-запросов, обновение БД не требуется
			{
				$this.iClientSuccess++;
    			if( $this.iClientSuccess == $this.iClientCount ) $this.bSuccessful = true;
    			$this.oSysupdateBase.append("Обновление БД на сервере для '"+sUserName+"' успешно выполнено.", "success");
    			$this.addGood(sAlias);
    			$this.clientsAjaxHandler(aaClients);
			}
			else
			{
				$this.oSysupdateBase.loading(true);
				if(formdata)
				{
		            formdata.append("ajax", 1);
		            formdata.append("sIP", sIP);
		            formdata.append("sDatabase", sDatabase);
		            formdata.append("sUserName", sUserName);
		            formdata.append("alias", sAlias);
		            formdata.append("operation", 'update_client_db');
		            formdata.append("action_name", "sql");
		            formdata.append("action_date", date);
		            formdata.append("action_zipname", zipname);
		            formdata.append("sSuffix", $this.sSuffix);
		            formdata.append("action_data", JSON.stringify($this.aClientSQL));

		            $.ajax({
		            	dataType: "json",
		                url: "/sysupdate",
		                type: "POST",
		                data: formdata,
		                processData: false,
		                contentType: false,
		                success: function (data)
		                {
		                	$this.oSysupdateBase.loading(false);
		                	var sColor = ( data.bResult ) ? "default" : "important";
		                	$this.oSysupdateBase.append(data.sMessage||"Ошибка. Обратитесь к разработчикам.", sColor);
		                	if( data.bResult )
		                	{
		                		$this.iClientSuccess++;
		            			if( $this.iClientSuccess == $this.iClientCount ) $this.bSuccessful = true;
		            			$this.oSysupdateBase.append("Обновление БД на сервере для '"+sUserName+"' успешно выполнено.", "success");
		            			$this.addGood(sAlias);
		            			$this.clientsAjaxHandler(aaClients);
		                	}
		                	else
		                	{
		                		$this.oSysupdateBase.errorsHandler($this, 1, oErrorParam);
		                	}
		               	},
			            error: function (XMLHttpRequest, textStatus, errorThrown)
			            {
			            	$this.oSysupdateBase.error(XMLHttpRequest, textStatus, errorThrown);
			            	$this.oSysupdateBase.errorsHandler($this, 1, oErrorParam);
						}
		            });
		        }
		        else
		        {
		        	oErrorParam.iBrowseError = 4; // Добавляем ошибку браузера
		        	$this.oSysupdateBase.errorsHandler($this, 1, oErrorParam);
		        }
			}
		},
		// Вызов функции находится в БАЗОВОМ ОБЪЕКТЕ: oSysupdateBase
		rollbackFullClient: function(aaClients, sIP, sDatabase, sUserName, sAlias, date, zipname)
		{
			// Сначала откатить БД объекта, потом вернуть объекта
			var $this 		= this,
				formdata 	= (window.FormData) ? new FormData() : false;
			$this.oSysupdateBase.loading(true);
			if(formdata)
			{
	            formdata.append("ajax", 1);
	            formdata.append("sDatabase", sDatabase);
	            formdata.append("alias", sAlias);
	            formdata.append("operation", 'recover_client_db');
	            formdata.append("action_date", date);
	            formdata.append("sSuffix", $this.sSuffix);

	            $.ajax({
	            	dataType: "json",
	                url: "/sysupdate",
	                type: "POST",
	                data: formdata,
	                processData: false,
	                contentType: false,
	                success: function (data)
	                {
	                	$this.oSysupdateBase.loading(false);
	                	var sColor = ( data.bResult ) ? "default" : "important";
	                	$this.oSysupdateBase.append(data.sMessage,sColor);
	                	if( data.bResult )
	                	{
	                		$this.oSysupdateBase.append("Отмена изменений БД объекта на сервере успешно завершена.", "success");
	                		$this.rollbackOnlyClient(aaClients, data.date);
	                	}
	                	else
	                	{
	                		$this.oSysupdateBase.errorsHandler(null, 2, null);
	                	}
	               	},
		            error: function (XMLHttpRequest, textStatus, errorThrown)
		            {
		            	$this.oSysupdateBase.error(XMLHttpRequest, textStatus, errorThrown);
		            	$this.oSysupdateBase.errorsHandler(null, 2, null);
					}
	            });
	        }
	        else
	        {
	        	$this.oSysupdateBase.errorsHandler(null, 6, 6);
	        }
		},
		rollbackOnlyClient: function(aaClients, sRollbackName)
		{
			var $this 		= this,
				formdata 	= (window.FormData) ? new FormData() : false;
			$this.oSysupdateBase.append("Начинаем операцию по откату изменений на стороне объекта.", "success");
			$this.oSysupdateBase.loading(true);
			if(formdata)
			{
	            formdata.append("recover", sRollbackName); // Полное имя
	            formdata.append("shortname", 1); // Полное имя
	            formdata.append("ajax", 1);
	            formdata.append("operation", 1);
	            $.ajax({
	            	dataType: "json",
	                url: "/sysupdate",
	                type: "POST",
	                data: formdata,
	                processData: false,
	                contentType: false,
	                success: function (data)
	                {
	                	$this.oSysupdateBase.loading(false);
	                	var sColor = ( data.bResult ) ? "default" : "important";
	                	$this.oSysupdateBase.append(data.sMessage,sColor);
	                	if( data.bResult )
	                	{
	                		$this.oSysupdateBase.append("Восстановление прошло успешно.", "success");
	                		$this.oSysupdateBase.append("Продолжаем работу.", "success");
	                		$this.clientsAjaxHandler(aaClients);
	                	}
	                	else
	                	{
	                		$this.oSysupdateBase.errorsHandler(null, 3, null);
	                	}
	               	},
		            error: function (XMLHttpRequest, textStatus, errorThrown)
		            {
		            	$this.oSysupdateBase.error(XMLHttpRequest, textStatus, errorThrown);
		            	$this.oSysupdateBase.errorsHandler(null, 3, null);
					}
	            });
	        }
	        else
	        {
	        	$this.oSysupdateBase.errorsHandler(null, 5, 7);
	        }
		},
		rollbackErrorClient: function(aaClients, sAlias, date, zipname, sIP)
		{
			var $this 		= this,
				formdata 	= (window.FormData) ? new FormData() : false;
			$this.oSysupdateBase.loading(true);
			$this.oSysupdateBase.append("Начинаем операцию по откату изменений.", "success");
			if( formdata )
			{
				formdata.append('ajax', 1);
				formdata.append('action_name', 'rollback');
				formdata.append("operation", 'curl_rollback');
				formdata.append('action_logname', "Начинаем операцию по откату данных");
				formdata.append('action_data', []);
				formdata.append('action_date', date);
				formdata.append('zipname', zipname);
				formdata.append('sIP', sIP);
				formdata.append("alias", sAlias);
				formdata.append('aCommitedActions', []);
				$.ajax({
		            	dataType: "json",
		                url: "/sysupdate",
		                type: "POST",
		                data: formdata,
		                processData: false,
		                contentType: false,
		                success: function (data)
		                {
		                	$this.oSysupdateBase.loading(false);
		                	var sColor = ( data.bResult ) ? "default" : "important";
		                	$this.oSysupdateBase.append(data.sMessage,sColor);
		                	if( data.bResult )
		                	{
		                		$this.oSysupdateBase.append("Отмена изменений на объекте прошла успешно.", "success");
		                		$this.oSysupdateBase.append("Продолжаем работу.", "success");
		                		$this.clientsAjaxHandler(aaClients);
		                	}
		                	else
		                	{
		                		$this.oSysupdateBase.append("Ошибка при восстановлении.", "important");
		                		$this.oSysupdateBase.append("Ошибка отмены изменений объекта. Сообщите об этом в службу поддержки.", sColor);
		                		$this.oSysupdateBase.saveInformation();
		                	}
		                },
			            error: function (XMLHttpRequest, textStatus, errorThrown)
			            {
			            	$this.oSysupdateBase.error(XMLHttpRequest, textStatus, errorThrown);
						}
		            });
			}
			else
	        {
	        	$this.oSysupdateBase.loading(false);
	        	$this.oSysupdateBase.errorsHandler(null, 4, 5);
	        }
		},
		clientsNewAjax: function(aClient, aaClients)
		{
			var $this 	= this,
			formdata 	= (window.FormData) ? new FormData() : false,
			sIP 		= aClient[0],
			sDatabase 	= aClient[1],
			oFileData 	= aClient[2],
			sUserName 	= aClient[3];
			var sAlias 		= aClient[4];
			$this.oSysupdateBase.append("Начинаем полное обновление для: '"+sUserName+"'.", "default");
			if(formdata)
			{
				$this.oSysupdateBase.loading(true);
				formdata.append("file", oFileData);
	            formdata.append("ajax", 1);
	            formdata.append("sIP", sIP);
	            formdata.append("sDatabase", sDatabase);
	            formdata.append("sUserName", sUserName);
	            formdata.append("alias", sAlias);
	            formdata.append("operation", 'curl_client');
	            formdata.append("sSuffix", $this.sSuffix);
	            formdata.append("action_data", JSON.stringify($this.aClientSQL));
	            $.ajax({
	            	dataType: "json",
	                url: "/sysupdate",
	                type: "POST",
	                data: formdata,
	                processData: false,
	                contentType: false,
	                success: function (data)
	                {
	                	$this.oSysupdateBase.loading(false);
	                	var sColor = ( data.bResult ) ? "default" : "important";
	                	$this.oSysupdateBase.append(data.sMessage, sColor);
                		if( data.bResult )
                		{
                			$this.oSysupdateBase.append("Данные на объекте успешно обновлены.", "success");
                			$this.oSysupdateBase.append("Приступаем к обновлению БД объекта на сервере.", "success");
                			// Обновляем БД объекта на сервере
                			$this.updateClientDB(aaClients, sIP, sDatabase, sUserName, sAlias, data.date, data.zipname);
                		}
                		else
                		{
                			$this.oSysupdateBase.append("Ошибка при обновлении: '"+sUserName+"'.", "important");
                			$this.addBad(sAlias);
                			if(data.curl_errno) // Нет соединения, значит и обновлений не было!
                			{
                				$this.oSysupdateBase.append("Номер об ошибки: '"+data.curl_errno+"'.", "important");
                				$this.oSysupdateBase.append("Сообщение об ошибке: '"+data.curl_error+"'.", "important");
                				if( data.curl_errno == 6 || data.curl_errno == 7 )
                				{
                					$this.oSysupdateBase.append("Нет соединения с объектом. Продолжаем обновление.'.", "default");
                					$this.clientsAjaxHandler(aaClients);
                				}
                				else
                				{
                					$this.rollbackErrorClient(aaClients, sAlias, data.date, data.zipname, sIP);
                				}
                			}
                			else
                			{
                				$this.rollbackErrorClient(aaClients, sAlias, data.date, data.zipname, sIP);
                			}

                		}
	                },
		            error: function (XMLHttpRequest, textStatus, errorThrown)
		            {
		            	$this.oSysupdateBase.loading(false);
		            	$this.addBad(sAlias);
		            	$this.oSysupdateBase.append("Ошибка при обновлении: '"+sUserName+"'.", "important");
    					$this.oSysupdateBase.append("Необходимо связаться со службой поддержки.", "important");
		            	$this.oSysupdateBase.error(XMLHttpRequest, textStatus, errorThrown);
					}
	            });
	        }
	        else
	        {
	        	$this.addBad(sAlias);
	        	$this.oSysupdateBase.errorsHandler(null, 4, 3);
	        	$this.oSysupdateBase.append("Ошибка при обновлении: '"+sUserName+"'.", "important");
	        	$this.oSysupdateBase.append("Продолжаем обновление следующих объектов.", "default");
    			$this.clientsAjaxHandler(aaClients);
	        }
		}
	}
	return oSysupdateClient.ini(oSysupdateBase);
}
